import React, { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { BookinPlanActions } from '../../../Services/_actions/BookingPlan/bookingPlan.actions';
import { useRecoilState } from 'recoil';
import { ContactListAtom } from '../../../Services/_states';
import ReactBootstrapTable from '../../Table/React-Bootstrap-table/ReactBootstrapTable';

export default function ContactDetailModal(props) {
  const { data } = props;
  const BookingApi = BookinPlanActions();
  const [contactList, setContactList] = useRecoilState(ContactListAtom);
  const addNewContact = {
    name: '',
    designation: '',
    email: '',
    relationship_status: '',
    comments: '',
    landline: '',
    mobile: '',
  };
  const [editEnable, setEditEnable] = useState(true);

  async function getContactDetails() {
    await BookingApi.getContactDetailsData(data);
  }
  const deleteContactObj = async (row, index) => {
    if (!row?.id) {
      let newList = [];
      for (let i in contactList) {
        if (i != index) {
          newList.push(contactList[i]);
        }
      }
      setContactList(newList);
    } else {
      // await BookingApi.deletContact(row, index);
    }
  };

  useEffect(() => {
    getContactDetails();
  }, []);

  const contactListHeader = [
    {
      title: 'NAME',
      accessKey: 'name',
      action: function (row, index) {
        return (
          <div>
            {editEnable ? (
              <span>{row?.name}</span>
            ) : (
              <Form.Control
                type="text"
                id="contactName"
                aria-describedby="contactName"
                value={row?.name}
                required
                disabled={editEnable}
                onChange={(e) => {}}
              />
            )}
          </div>
        );
      },
    },
    {
      title: 'DESIGNATION',
      accessKey: 'contact_type',
      sort: false,
      action: function (row, index) {
        return (
          <div>
            {editEnable ? (
              <span>{row?.contact_type}</span>
            ) : (
              <Form.Control
                type="text"
                id="contactName"
                aria-describedby="contactName"
                value={row?.contact_type}
                required
                disabled={editEnable}
                onChange={(e) => {}}
              />
            )}
          </div>
        );
      },
    },
    {
      title: 'EMAIL',
      accessKey: 'email',
      sort: false,
      action: function (row, index) {
        return (
          <div>
            {editEnable ? (
              <span>{row?.contact_type}</span>
            ) : (
              <Form.Control
                type="text"
                id="email"
                aria-describedby="email"
                value={row?.email}
                required
                disabled={editEnable}
                onChange={(e) => {}}
              />
            )}
          </div>
        );
      },
    },
    {
      title: 'RELATIONSHIP STATUS',
      accessKey: 'relationship_status',
      sort: false,
      action: function (row, index) {
        return (
          <div>
            {editEnable ? (
              <span>{row?.relationship_status}</span>
            ) : (
              <Form.Control
                type="text"
                id="relationship_status"
                aria-describedby="relationship_status"
                value={row?.relationship_status}
                required
                disabled={editEnable}
                onChange={(e) => {}}
              />
            )}
          </div>
        );
      },
    },
    {
      title: 'COMMENTS',
      accessKey: 'comments',
      sort: false,
      action: function (row, index) {
        return (
          <div>
            {editEnable ? (
              <span>{row?.comments}</span>
            ) : (
              <Form.Control
                type="text"
                id="comments"
                aria-describedby="comments"
                value={row?.comments}
                required
                disabled={editEnable}
                onChange={(e) => {}}
              />
            )}
          </div>
        );
      },
    },
    {
      title: 'LANDLINE NO',
      accessKey: 'landline',
      sort: false,
      action: function (row, index) {
        return (
          <div>
            {editEnable ? (
              <span>{row?.landline}</span>
            ) : (
              <Form.Control
                type="text"
                id="comments"
                aria-describedby="comments"
                value={row?.landline}
                required
                disabled={editEnable}
                onChange={(e) => {}}
              />
            )}
          </div>
        );
      },
    },
    {
      title: 'MOBILE',
      accessKey: 'mobile',
      sort: false,
      action: function (row, index) {
        return (
          <div>
            {editEnable ? (
              <span>{row?.mobile}</span>
            ) : (
              <Form.Control
                type="text"
                id="comments"
                aria-describedby="comments"
                value={row?.mobile}
                required
                disabled={editEnable}
                onChange={(e) => {}}
              />
            )}
          </div>
        );
      },
    },
    {
      title: 'REMOVE',
      accessKey: 'index',
      sort: false,
      action: function (row, index) {
        return (
          <div className="action-icon">
            <span
              className="action-icon-item"
              onClick={(e) => {
                deleteContactObj(row, index);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-trash"
                viewBox="0 0 16 16"
              >
                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
              </svg>
            </span>
          </div>
        );
      },
    },
  ];
  return (
    <>
      <div>
        {contactList && (
          <ReactBootstrapTable headerData={contactListHeader} rowData={contactList} />
        )}
        <div className="pt-4">
          <div className="d-flex justify-content-between">
            <div>
              <span>
                <Button
                  className="btn me-3 btn-primary"
                  onClick={(e) => {
                    setContactList([...contactList, addNewContact]);
                  }}
                >
                  Add
                </Button>
              </span>
              <span>
                <Button className="btn me-3 btn-success">Save</Button>
              </span>
            </div>
            <div>
              <span>
                <Button
                  className="btn me-3 btn-primary"
                  onClick={(e) => {
                    setEditEnable(!editEnable);
                  }}
                >
                  Edit
                </Button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
